import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { FieldsEditorActionManagerService } from '../../fields-editor/fields-editor-action-manager.service'
import { FieldPlaceholderComponent } from '../field-placeholder.component'
import { SignFieldType } from '@tokeet-frontend/signature'

@Component({
  selector: 'app-signdate-placeholder',
  templateUrl: './signdate-placeholder.component.html',
  styleUrls: ['./signdate-placeholder.component.scss', '../global-fields.scss'],
})
export class SigndatePlaceholderComponent extends FieldPlaceholderComponent {
  type = SignFieldType.Signdate

  defaultLabel = $localize`Sign Date`

  @Input() required = true
  @Input() label: string

  constructor(
    render: Renderer2,
    fb: FormBuilder,
    elementRef: ElementRef,
    actionManager: FieldsEditorActionManagerService
  ) {
    super(render, fb, elementRef, actionManager)
  }
}
